import { FC } from 'react';
import { Button, Spinner } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  onClick: (event: any) => Promise<void>;
  isLoading?: boolean;
}

const ButtonClean: FC<IProps> = ({
  onClick,
  isLoading
}) => {
  return (
    <Button
      type="button"
      onClick={(e) => onClick(e)}
    >
      {isLoading &&
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      }
      <FontAwesomeIcon icon={faEraser} className='me-2' />
      <span>{t("CLEAN")}</span>
    </Button>
  );
}

export default ButtonClean;